<template functional>
 <span class="icon"
       :class="`icon--${props.icon}`">
    <svg>
      <title>{{ props.icon }}</title>

      <use :xlink:href="`#icon--${props.icon}`"></use>
    </svg>
  </span>
</template>

<script>
  export default {
    name: 'PFSvGIcon',

    props: {
      icon: {
        type: String,
        required: true
      }
    }
  }
</script>
